/* This is the emis Intestinal components */
<template>
  <v-container>
    <div>
      <span v-html="title + ' ' + lst_acc"></span>
    </div>
    <table style="height: 72px" width="650px;" border="1px;" cellspacing="0px;">
      <tbody>
        <tr>
          <td
            style="width: 250px; text-align: center; vertical-align: middle"
            rowspan="2"
          >
            បានទទួលថ្នាំព្រូន (សូមគូសរង្វង់)
          </td>
          <td class="td-row-header" colspan="2">
            ប្រសិនបើបាន, មានប៉ុន្មានគ្រាប់ដែលបានទទួលក្នុង១លើក
          </td>
          <td class="td-row-header" colspan="2">
            មានសិស្សប៉ុន្មាននាក់ដែលបានទទួលក្នុង១លើក
          </td>
        </tr>
        <tr>
          <td class="td-row-data">លើកទី១</td>
          <td class="td-row-data">លើកទី២</td>
          <td class="td-row-data">លើកទី១</td>
          <td class="td-row-data">លើកទី២</td>
        </tr>
        <tr>
          <td style="width: 250px; text-align: center; vertical-align: middle">
            <v-select
              class="py-0 px-1"
              v-model="data.dt[0]"
              :items="yesNo5"
              item-text="text"
              item-value="value"
              hide-details
              outline
              @keypress.native="onSelect($event)"
            >
            </v-select>
          </td>
          <td class="td-row-data">
            <numberinput v-model="data.dt[1]" class="number" />
          </td>
          <td class="td-row-data">
            <numberinput v-model="data.dt[2]" class="number" />
          </td>
          <td class="td-row-data">
            <numberinput v-model="data.dt[3]" class="number" />
          </td>
          <td class="td-row-data">
            <numberinput v-model="data.dt[4]" class="number" />
          </td>
        </tr>
      </tbody>
    </table>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { yesNo5 } from "@/utils/ascf/commonConfig.js";
export default {
  props: ["data", "title", "lst_acc"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      yesNo5: yesNo5,
    };
  },
  methods: {
    onSelect: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data.dt[0] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
/*@import './assets/styles/ascfstyle.css';*/
.number {
  width: 50px;
  text-align: center;
}
.td-row-title {
  width: 150px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.td-row-header {
  width: 100px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.td-row-data {
  width: 100px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-size: 14px;
}
</style>
